import { StarFilledIcon } from '@/shared/components/icons';
import { Img } from '@/shared/components/ui/Img';
import { cn } from '@/shadcn/lib/utils';
import { PhoneIcon, MessageIcon, WhatsappIcon } from '@/shared/components/icons';

interface Props {
    data: any;
}

export function AgencyBrokerCard(props: Props) {
    const CONTACTS = [
        {
            icon: <PhoneIcon className="w-[15px] sm:w-[12px] md:w-[15px]" />,
        },
        {
            icon: <MessageIcon className="w-[15px] fill-[#000] sm:w-[12px] md:w-[15px]" />,
        },
        {
            icon: <WhatsappIcon className="w-[15px] sm:w-[12px] md:w-[15px]" />,
        },
    ];

    return (
        <div
            className={cn(
                'grid grid-cols-[1fr_3fr] gap-[15px] border border-[#ececec] rounded-[15px] bg-[#fbfbfb] p-[12px]',
                'sm:gap-[12px] sm:p-[12px]',
                'md:p-[17px] md:gap-[15px]',
                'xl:p-[20px] xl:gap-[20px]',
            )}
        >
            <div className="flex flex-col items-center gap-[20px] sm:gap-[20px] md:gap-[20px]">
                <div
                    className={cn(
                        'size-[80px] p-[7px] shadow-[0_3px_6px_rgba(0,0,0,0.1)] rounded-full',
                        'sm:size-[70px]',
                        'md:size-[80px]',
                        'xl:size-[85px]',
                    )}
                >
                    <div className={cn('w-full h-full rounded-full overflow-hidden')}>
                        <Img
                            className="object-cover w-full h-full"
                            src="/images/image_placeholder.png"
                            alt="broker profile photo"
                        />
                    </div>
                </div>
                <div className="flex justify-center w-full gap-[5px]">
                    <StarFilledIcon className="w-[9px] fill-cust-primary" />
                    <StarFilledIcon className="w-[9px] fill-cust-primary" />
                    <StarFilledIcon className="w-[9px] fill-cust-primary" />
                </div>
                <div className="text-center -mt-[8px]">
                    <small className="text-[17px] font-[700] sm:text-[15px] md:text-[17px] xl:text-[18px]">
                        23
                    </small>
                    <p className="text-[11px] font-[500] -mt-[3px] sm:text-[10px] md:text-[11px] xl:text-[12px]">
                        recenzií
                    </p>
                </div>
            </div>
            <div className="pt-[20px]">
                <h4 className="font-[700] text-[15px] mb-[10px] sm:text-[14px] md:text-[15px] xl:text-[16px]">
                    Jaroslav Rosenberg
                </h4>
                <p className="text-[13px] leading-[130%] sm:text-[11px] md:text-[13px]">
                    Biela 126/2, Presov
                </p>
                <a
                    className="text-[13px] leading-[130%] font-[700] sm:text-[11px] md:text-[13px]"
                    href="tel:+421 914 750 587"
                >
                    +421 914 750 587
                </a>
                <a
                    className="text-[13px] leading-[130%] block sm:text-[11px] md:text-[13px]"
                    href="mailto:resenberg@maximareak.sk"
                >
                    resenberg@maximareak.sk
                </a>
                <div className="flex justify-end mt-[20px]">
                    <div className="flex gap-[10px] sm:gap-[7px] md:gap-[10px]">
                        {CONTACTS.map((contact, i) => {
                            return (
                                <a
                                    key={i}
                                    href="#"
                                    className={cn(
                                        'size-[32px] flex items-center justify-center border rounded-full',
                                        'sm:size-[27px]',
                                        'md:size-[32]',
                                    )}
                                >
                                    {contact.icon}
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
